import { render } from "./PublicProfilePage.vue?vue&type=template&id=36bb9b62&scoped=true&ts=true"
import script from "./PublicProfilePage.vue?vue&type=script&lang=ts"
export * from "./PublicProfilePage.vue?vue&type=script&lang=ts"

import "./PublicProfilePage.vue?vue&type=style&index=0&id=36bb9b62&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bb9b62"]])

export default __exports__